 <template>
  <v-form ref="formSpend" v-model="validForm" lazy-validation>
    <v-text-field label="Concepto de pago" :rules="rules.lonxl" v-model="concept"></v-text-field>
    <v-row>
      <v-col cols="6">        
           <v-autocomplete
          label="Tipo de Egreso"
          v-model="tipo_egreso"
          :items="['Preventivo', 'Correctivo', 'Extraordinario', 'Equipamiento']"
        ></v-autocomplete>
      </v-col>
      <v-col cols="6">       
       <v-autocomplete
          item-text="name"
          item-value="id"
          label="Tipo de pago"
          v-model="paymentTypeId"
          :items="paymentItems"
        ></v-autocomplete>  
      </v-col>
    </v-row>
     <v-col>
        <v-text-field label="Proveedor" :rules="rules.lonxl" v-model="supplier"></v-text-field>
      </v-col>
    <v-row>
      <v-col cols="6">
        <label for="date"
          ><DatePicker           
            label="Fecha Gasto"
            name="date"
            @change="fecha = $event"
        /></label>
      </v-col>
      <v-col cols="6">
        <v-text-field 
          label="Núm cheque" 
          :rules="rules.lonlg"
          v-model="referencia"
          hint="Núm cheque, transferencia o depósito"
          ></v-text-field>        
      </v-col>
    </v-row>
    <v-row>
      <v-textarea label="Descripción" :rules="rules.lonxxl" filled outlined v-model="description"></v-textarea>
    </v-row>
    <v-text-field prefix="$" suffix="MXN" label="Importe a pagar" v-model="amount"></v-text-field>
    <v-btn @click="savenewspend" depressed color="#00aff2" dark> Registrar pago </v-btn>    
  </v-form>
</template>
 
<script>
import adminSuppliersService from '@/services/admin/supplierPayments';
import DatePicker from '@/components/DatePicker.vue';
//import dayjs from 'dayjs';

export default {
  components: {
    DatePicker,
  },
  data: () => ({
    validForm: true,
    concept: '',
    description: '',
    paymentTypeId: '',
    supplier: '',
    amount: 0,    
    fecha: new Date(),
    tipo_egreso: '',
    referencia: '',
    paymentItems: [],
    rules: {
          required: (value) => !!value || 'Required.',         
          lonsm: [ (v) => !v || v.length <= 50 || 'Nombre debe ser menor a 50 caracteres' ],
          lonmd: [ (v) => !v || v.length <= 60 || 'Nombre debe ser menor a 60 caracteres' ],
          lonlg: [ (v) => !v || v.length <= 100 || 'Nombre debe ser menor a 100 caracteres' ],
          lonxl: [ (v) => !v || v.length <= 255 || 'Nombre debe ser menor a 255 caracteres' ],
          lonxxl: [ (v) => !v || v.length <= 1024 || 'Nombre debe ser menor a 1024 caracteres' ],
          },
  }),
  mounted() {
    this.paymentTypes();
  },
  methods: {
    paymentTypes() {
      adminSuppliersService.paymentTypes().then((response) => {
        this.paymentItems = response.data;
      });
    }, 
    savenewspend() {    
      console.log(this.fecha);
      const data = {
        concept: this.concept,
        description: this.description,        
        paymentTypeId: this.paymentTypeId,
        supplier: this.supplier,
        amount: this.amount,
        fecha: this.fecha,
        tipo_egreso: this.tipo_egreso,
        referencia: this.referencia,
      };
      if (this.$refs.formSpend.validate()) {
        adminSuppliersService
          .createPayment(data)
          .then(() => {
            this.concept = '';
            this.description = '';           
            this.paymentTypeId = '';
            this.supplier = '';
            this.amount = 0;
            this.fecha = new Date();
            this.referencia = '';
            this.tipo_egreso = '';
            this.$emit('on-save');
            this.$swal('Pago creado', 'El pago realizado se ha registrado con éxito', 'success');
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al registrar egreso', error.response.data.message, 'warning');
            }
          });
      }
    },
  },
  watch: {
    fecha(newVal) {
      console.log(newVal);
    }
  }
};
</script>